import type { CourseDraftUpdatePrice } from './courseDraftUpdatePrice';
import type { CourseDraftUpdateSectionsItem } from './courseDraftUpdateSectionsItem';

/**
 * 코스 초안 업데이트 요청
 */
export interface CourseDraftUpdate {
  /**
   * 코스 설명
   * @maxLength 2000
   * @nullable
   */
  description?: string | null;
  /**
   * 코스 난이도 (자유 텍스트 입력)
   * @minLength 1
   * @maxLength 50
   * @nullable
   */
  level?: string | null;
  /**
   * 코스 가격 정보
   * @nullable
   */
  price?: CourseDraftUpdatePrice;
  /**
   * 코스 섹션 목록
   * @nullable
   */
  sections?: CourseDraftUpdateSectionsItem[] | null;
  /**
   * 썸네일 이미지 URL
   * @nullable
   */
  thumbnailUrl?: string | null;
  /**
   * 코스 제목
   * @minLength 1
   * @maxLength 200
   * @nullable
   */
  title?: string | null;
}
